import { render, staticRenderFns } from "./read-terms-modal.vue?vue&type=template&id=a4234bcc&scoped=true"
import script from "./read-terms-modal.vue?vue&type=script&lang=js"
export * from "./read-terms-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4234bcc",
  null
  
)

export default component.exports